var React = require('react');

function SeparatorShape (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M871 18H0C0 18 7 0.999998 107 0.999998C159.5 0.999998 677 0.499998 764 0.999998C864 1.5 871 18 871 18Z","fill":"#C32B5E"}));
}

SeparatorShape.defaultProps = {"width":"871","height":"18","viewBox":"0 0 871 18","fill":"none"};

module.exports = SeparatorShape;

SeparatorShape.default = SeparatorShape;
